/**
Author - Brijesh Pandey
Git - https://github.com/Brijesh-Pandey
**/

import DigioInitialization from "./DigioInitialization";

export default DigioInitialization;